import {
  Module,
  VuexModule,
  getModule,
  Mutation,
  Action
} from "vuex-module-decorators";
import store from "@/store";
import Solicitacao from "@/models/solicitacao";

@Module({
  dynamic: true,
  namespaced: true,
  name: "solicitacao",
  store
})
class SolicitacaoModule extends VuexModule {
  solicitacao: Solicitacao = new Solicitacao();
  stepperOneValid: boolean = false;
  stepperTwoValid: boolean = false;
  stepperThreeValid: boolean = false;
  isLoading: boolean = false;
  sendedSolicitation: boolean = false;
  codigoSolicitation: number = null;
  steps: number = 3;
  currentStep: number = 1;

  @Mutation
  setSolicitacao(solicitacao: Solicitacao): void {
    this.solicitacao = solicitacao;
  }

  @Mutation
  setstepperOneValid(valid: boolean): void {
    this.stepperOneValid = valid;
  }

  @Mutation
  setstepperTwoValid(valid: boolean): void {
    this.stepperTwoValid = valid;
  }

  @Mutation
  setstepperThreeValid(valid: boolean): void {
    this.stepperThreeValid = valid;
  }

  @Mutation
  setIsLoading(value: boolean): void {
    this.isLoading = value;
  }

  @Mutation
  setSendedSolicitation(value: boolean): void {
    this.sendedSolicitation = value;
  }

  @Mutation
  setCodigoSolicitation(value: number): void {
    this.codigoSolicitation = value;
  }

  @Mutation
  setCurrentStep(value: number): void {
    this.currentStep = value;
  }

  @Mutation
  reset(): void {
    this.solicitacao = new Solicitacao();
    this.stepperOneValid = false;
    this.stepperTwoValid = false;
    this.stepperThreeValid = false;
    this.isLoading = false;
    this.sendedSolicitation = false;
    this.codigoSolicitation = null;
    this.currentStep = 1;
  }

  @Action
  changeSolicitacao(solicitacao: any) {
    this.context.commit("setSolicitacao", solicitacao);
  }
}

export default getModule(SolicitacaoModule);
